module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/qd-pengdashuai-manifesto.8ec84559.png";